import {DataInput, DataListOption} from "../models/DataCollectionPaneConfig";
import {settings} from "../../../../settings/settings-util";
import {VTree, VNode} from "virtual-dom";
import h from "virtual-dom/h";
import {buildErrorMessages} from "./ErrorMessages";
import {buildLabelText} from "./Label";
import {Dictionary} from "../../../../types/rendering";


const getSelectedOption = (htmlInput: HTMLInputElement | null, dataInput: DataInput): DataListOption | undefined =>
{
    return  dataInput.dataListOptions?.find(option => htmlInput?.value.trim() === option.displayText);
};

const getShouldBeHidden = (input: DataInput, dataInputs: DataInput[]): boolean =>
{
    return input.hidden ? !dataInputs.some(dataInput =>
    {
        const htmlInput = document.querySelector(`#${dataInput.id}`) as HTMLInputElement;
        const option = getSelectedOption(htmlInput, dataInput);

        return option?.showDataInputId === input.id;
    }) : false;
};

const buildInput = (input: DataInput, classNames: typeof settings.classNames, onInput: () => void): VNode =>
{
    const params: Dictionary =
    {
        attributes: { list: `${input.id}-list` },
        id: input.id,
        placeholder: input.placeholder,
        className: classNames.dataCollectionPaneDataList,
        maxLength: input.maxLength,
        required: input.required === 'true',
        oninput: onInput,
    };

    return h("input", params, []);
};

const buildDataList = (input: DataInput): VNode =>
{
    const options = input.dataListOptions?.map(option => h("option", { value: option.displayText }, []));

    return h('datalist', { id: `${input.id}-list` }, options ?? []);
};

const buildDataListField = (input: DataInput, dataInputs: DataInput[], passedSettings: typeof settings, onInput: () => void, onBlur: () => void): VTree[] =>
{
    const lastElementID = dataInputs[dataInputs.length - 1].id;
    const labelText = buildLabelText(input, passedSettings.classNames);
    const inputElement = buildInput(input, passedSettings.classNames, onInput);
    const dataList = buildDataList(input);
    const errors = buildErrorMessages(input, passedSettings);

    const params: Dictionary =
    {
        className: passedSettings.classNames.dataCollectionPaneTextBoxLabel,
        hidden: getShouldBeHidden(input, dataInputs),
        id: `${input.id}-label`,
        onblur: onBlur,
    };
    if(input.id === lastElementID)
    {
    const label = h('label', params, [...labelText, inputElement, dataList, errors]);

    return [label];
    }
    else
    {
        const label = h('label', params, [...labelText, inputElement, dataList]);

       return [label];
    }
};

export {
    buildDataListField,
    buildDataList,
    buildInput,
    getSelectedOption,
    getShouldBeHidden
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/elements/DataList.ts